<template>
  <div class="qeustionIndex">
    <div class="listMain">
      <van-list
        v-model="loading"
        :error.sync="error"
        :finished="finished"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div v-for="item in questionList" :key="item.id" class="question-item" @click="goDetail(item)">
          <img :src="flag" alt="" class="question-item-flag">
          <div class="question-item-right">
            <div class="question-name">{{item.name}}</div>
            <div class="question-num">{{item.realNum}}人已参与</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { getQueList } from '../../api/question'
import store from '../../store/index'
export default {
  data() {
    return {
      flag: require('../../assets/images/question/flag.png'),
      loading: false,
      finished: false,
      error: false,
      config: {
        pageNum: 0,
        pageSize: 10,
        status: 1,
        isprivate: 0 // 非私密问卷
      },
      questionList: [],
      arr: [],
      userInfo: store.getters.userInfo
    }
  },
  methods: {
    async onLoad() {
      this.config.pageNum +=1
      let res = await getQueList(this.config)
      const list1 = res.data.list
      this.questionList = this.questionList.concat(list1)
      this.loading = false
      if (res.data.isLastPage) {
        this.finished = true
      }
    },
    goDetail(item) {
      this.$router.push({
        path: '/question/detail',
        query: {
          qid: item.qcode,
          t_id: store.getters.userInfo.user.id
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.qeustionIndex {
  background: #fff
  padding: 30px 30px 130px 30px;
  .question-item {
    display: flex;
    border-bottom: 1PX solid rgba(51, 51, 51, 0.1)
    padding: 30px 0;
    &:last-child {
      boder-bottom: none !important
    }
    .question-item-flag {
      width: 104px;
      height: 115px;
      margin-right: 24px;
    }
    .question-item-right {
      flex: 1;
      overflow: hidden;
      .question-name {
        color: #333333;
        font-size: 30px;
        font-weight: bold;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .question-num {
        color: #888888;
        font-size: 24px;
        margin-top: 36px;
      }
    }
  }
}
</style>